import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { InputBasicTextArea } from '../../components/common/Inputs';
import { FileAddList } from '../../components/common/FileAddList';
import { SiteSurveyAction, CalendarAction, ProductAction } from '../../actions';
import SurveyStep0 from './SurveyStep0';
import SurveyStep1 from './SurveyStep1';
import SurveyStep2 from './SurveyStep2';
import SurveyStep3 from './SurveyStep3';
import { ExportPdfReport } from '../../components/common/ExportPdfReport';
import AccordionSection from '../../components/common/AccordionSection';
import { Translate as t } from '../../config/Translate';

const SurveyStep4 = ({ Update, CreateSchedule, info, view = "", SendReportMail, gostep }) => {

	// const [t] = useTranslation();
	const userCompanyId = JSON.parse(localStorage.getItem("user") || '{}').companyId;
	const [siteSurvey, setSiteSurvey] = useState({ ...info, siteSurveyStep: 6, isSubmit: true });
	const [showTab, setShowTab] = useState({
		tab1: true,
		tab2: false,
		tab3: false,
		tab4: false,
	});

	useEffect(() => {
		setSiteSurvey(info);
	}, [info]);

	// 캘린더 생성은 validNext()에서만 수행 — useEffect 시점에는
	// siteSurvey state가 info prop으로 아직 갱신되지 않아 불완전한 데이터 전송 위험
	useEffect(() => {
		if (gostep && gostep.curStep === 5 && typeof gostep.goStepNo === 'number' && gostep.goStepNo > 0) {
			try {
				Update(info._id, { ...info, siteSurveyStep: gostep.goStepNo });
			} catch (error) {
				console.warn('[SurveyStep4] Failed to update step:', error.message);
			}
		}
	}, [gostep, info]);


	const Prev = (e) => {
		Update(siteSurvey._id, { ...siteSurvey, siteSurveyStep: 4 });
	};

	const validNext = async () => {
		try {
			await CreateSchedule({
				color: "bg-danger",
				finish: siteSurvey.scheduleDate + 1000 * 60 * 60,
				model: siteSurvey.model,
				option: siteSurvey.option,
				owner: siteSurvey.companyId || userCompanyId,
				siteId: siteSurvey.sitesurveyId,
				sitename: siteSurvey.siteSitename,
				sn: siteSurvey.sn,
				start: siteSurvey.scheduleDate,
				type: "Install"
			});
			Update(siteSurvey._id, { ...siteSurvey, siteSurveyStep: 6, isSubmit: true });
		} catch (error) {
			console.warn('[SurveyStep4] Failed to create schedule:', error.message);
		}
	};

	const SendEmail = () => {
		//var result = ExportPdfReportToEmail('sitesurvey', info);
		//////SendReportMail(siteSurvey._id, info);
		//console.log(result);
	};

	return (
		<>
			<div className="section mt-1 inset">
				<div className="section-title">{t('common.label.summary')}</div>
			</div>
			<div className="section">
				<AccordionSection isOpen={showTab.tab1} onToggle={() => setShowTab({ ...showTab, tab1: !showTab.tab1 })} title={t('site.label.siteInfo')}>
					<SurveyStep0 info={siteSurvey} isSummary={true} />
				</AccordionSection>
				<AccordionSection isOpen={showTab.tab2} onToggle={() => setShowTab({ ...showTab, tab2: !showTab.tab2 })} title={t('product.label.productInfo')}>
					<SurveyStep1 info={siteSurvey} isSummary={true} />
				</AccordionSection>
				<AccordionSection isOpen={showTab.tab3} onToggle={() => setShowTab({ ...showTab, tab3: !showTab.tab3 })} title={t('service.label.deliveryInfo')}>
					<SurveyStep2 info={siteSurvey} isSummary={true} />
				</AccordionSection>
				<AccordionSection isOpen={showTab.tab4} onToggle={() => setShowTab({ ...showTab, tab4: !showTab.tab4 })} title={t('installation.field.roomDimensions')}>
					<SurveyStep3 info={siteSurvey} isSummary={true} />
				</AccordionSection>
			</div>
			{view == "view" &&
				<div className="mb-3 mt-2 ms-2 me-2">
					{/* <button className="btn btn-primary btn-block btn-lg" onClick={() => SendEmail()}>{t("email")}</button> */}
					<ExportPdfReport reportType={'sitesurvey'} infos={info} />
					<button className="btn btn-outline-primary btn-block btn-lg" onClick={() => history.back()}>{t('common.button.close')}</button>
				</div>
			}
			{view != "view" &&
				<div className="section mt-1 mb-2">
					<button className="btn btn-primary btn-block btn-lg" onClick={() => validNext()}>{t('common.button.complete')}</button>
					<button className="btn btn-dark btn-block btn-lg mt-1" onClick={() => Prev()}>{t('common.button.back')}</button>
				</div>
			}
		</>
	);
};

const mapDispatch = (dispatch) => ({
	Update: (_id, data) => dispatch(SiteSurveyAction.UpdateSiteSurvey(_id, data)),
	CreateSchedule: (data) => dispatch(CalendarAction.Create(data)),
	SendReportMail: (_id, data) => dispatch(SiteSurveyAction.SendReportMail(_id, data))
});

export default connect(null, mapDispatch)(SurveyStep4);